import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/endpoint';

export const massMediaUrl = `${SERVER_API}/mass-media-registry/mass-media`;
export const massMediaActualizationUrl = `${SERVER_API}/mass-media-registry/actualization`;
export const MASS_MEDIA_API = {
  ...generateCrudEndpoints(massMediaUrl),
  EXPORT_REGISTRY: {
    method: 'GET',
    url: `${massMediaUrl}/export-registry`,
  } as IEndpointData,
  ACTUALIZATION: {
    ACTUALIZATION_STORE: {
      method: 'POST',
      url: `${massMediaActualizationUrl}`,
    } as IEndpointData,
    ACTUALIZATION_UPDATE: (id: string | number): IEndpointData => ({
      method: 'PUT',
      url: `${massMediaActualizationUrl}/${id}`,
    }),
    ACTUALIZATION_DELETE: (id: string | number): IEndpointData => ({
      method: 'DELETE',
      url: `${massMediaActualizationUrl}/${id}`,
    }),
    ACTUALIZATION_RKN: {
      method: 'POST',
      url: `${massMediaUrl}/actualization/rkn`,
    } as IEndpointData,
    ACTUALIZATION_RKN_SINGLE: (id: string | number): IEndpointData => ({
      method: 'POST',
      url: `${massMediaUrl}/${id}/actualization/rkn`,
    }),
  },
  EXCLUDE: (id: string | number): IEndpointData => ({
    method: 'POST',
    url: `${massMediaUrl}/${id}/exclude`,
  }),
  RESTORE: (id: string | number): IEndpointData => ({
    method: 'POST',
    url: `${massMediaUrl}/${id}/restore`,
  }),
};
